// extracted by mini-css-extract-plugin
export default {"loading_block":"LoadingBlock_loading_block__HtgWf","loadingBlock":"LoadingBlock_loading_block__HtgWf"};